import React, { useEffect } from "react";
import { browserHistory, withRouter } from "react-router";
const TechSpecsRedirection = ({params}) => {
    useEffect(() => {
        browserHistory.push(`/technical-specification/${params.type}/${params.aircraft_slug}/basic-details`)
    },[]);
    return <></>
}
export default withRouter(TechSpecsRedirection);